import { LitElement, html, css, t } from '@hh/global.js'
class InlineFilter extends LitElement {
  static properties = {
    _activeFacets: {
      state: true,
      type: Array,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this._initActiveFacets()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updated(changedProperties) {
    if (changedProperties.has('_activeFacets')) {
      this._emitActiveFacets()
    }
  }

  _emitActiveFacets() {
    const param = this.filter.param_name

    this.dispatchEvent(
      new CustomEvent('active-facets', {
        bubbles: true,
        composed: true,
        detail: { [param]: this._activeFacets },
      })
    )
  }

  onFacetChange(e) {
    const { value, checked } = e.detail
    if (checked) {
      this._activeFacets = [...this._activeFacets, value]
    } else {
      this._activeFacets = this._activeFacets.filter((facet) => facet !== value)
    }
  }

  onReset() {
    this._activeFacets = []
  }

  _initActiveFacets() {
    const currentlyActiveFacets = this.filter.values.filter(
      (facet) => facet.active
    )
    if (currentlyActiveFacets.length) {
      this._activeFacets = currentlyActiveFacets.map((facet) => facet.value)
      return
    }
    this._activeFacets = []
  }

  render() {
    return html`
      <ul
        class="facet-list"
        @facet-change=${this.onFacetChange}
        @facet-reset=${this.onReset}
      >
        <hh-inline-facet-reset
          ._activeFacets=${this._activeFacets}
          .tAll=${this.tAll}
        ></hh-inline-facet-reset>
        ${this.filter.values.map((facet, index) => {
          return html`
            <hh-inline-facet
              .facet=${facet}
              .filter=${this.filter}
              .index=${index}
              ._activeFacets=${this._activeFacets}
              form="filter-form"
            ></hh-inline-facet>
          `
        })}
      </ul>
    `
  }

  static styles = css`
    .facet-list {
      list-style: none;
      display: flex;
      overflow-x: auto;
      gap: 2.2rem 1rem;
      margin: 0;
      padding: 2rem 0;
      -ms-overflow-style: none;
      scrollbar-width: none;
      max-width: 100vw;
      overflow-x: scroll;
      position: relative;
      white-space: nowrap;
    }

    .facet-list::-webkit-scrollbar {
      display: none;
    }

    @media screen and (min-width: 990px) {
      :host {
        margin-top: 2rem;
      }
    }

    @media screen and (min-width: 990px) {
      .facet-list {
        flex-wrap: wrap;
        padding: 2rem 0 3rem;
      }
    }
  `
}

customElements.define('hh-inline-filter', InlineFilter)
